import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParSchoolLevel from './par-school-level';
import ParSchoolLevelDetail from './par-school-level-detail';
import ParSchoolLevelUpdate from './par-school-level-update';
import ParSchoolLevelDeleteDialog from './par-school-level-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParSchoolLevelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParSchoolLevelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParSchoolLevelDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParSchoolLevel} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParSchoolLevelDeleteDialog} />
  </>
);

export default Routes;
